import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClientClientReferralList from './ClientClientReferralList';
import {
  assignSpoc,
  centralValidate,
  getReferralList,
  getRejectReasons,
  getSpocList,
  getStatusHistory,
  rejectLead,
  validateLead,
  setLeadStage,
} from 'services/redux/clientClientReferral/action';

const mapStateToProps = (state) => ({
  referralList: state.clientClientReferralReducer.referralList,
  spocOptions: state.clientClientReferralReducer.spocOptions,
  rejectReasons: state.clientClientReferralReducer.rejectReasons,
  statusHistory: state.clientClientReferralReducer.statusHistory,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getReferralList,
      getSpocList,
      getRejectReasons,
      getStatusHistory,
      assignSpoc,
      validateLead,
      rejectLead,
      centralValidate,
      setLeadStage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClientClientReferralList);
